import React from 'react';
import { UpdateType } from '@debbie/common/dist/updates';
import Panel from './Panel';
const BaseUpdate = (props) => {
    if (props.item.updateTypeId === UpdateType.CASESTATUSMOVE ||
        !props.item.update) {
        return null;
    }
    return (React.createElement(Panel, null,
        React.createElement("div", null, props.item.update)));
};
export default BaseUpdate;
//# sourceMappingURL=BaseUpdate.js.map